import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { fetchNotification, NOTIFICATION_MAX_SIZE } from "../../helper/Api";
import { useStateSafe } from "../../helper/customHook";
import { errors, getApiError } from "../../helper/Error";
import TopBar from "../common/TopBar";
import classNames from "classnames";
import InfiniteScroll from "react-infinite-scroller";
import { get曜日 } from "../../helper/JapanDate";
import { format } from "date-fns";
import ErrorDialog from "../common/ErrorDialog";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: theme.spacing(2),
    },
    name: {
      textAlign: "left",
      width: "100%",
      maxWidth: "600px",
      marginBottom: theme.spacing(4),
      fontSize: 21,
    },
    note: {
      textAlign: "left",
      width: "100%",
      maxWidth: "600px",
    },
    day: {
      marginTop: theme.spacing(3),
    },
    paper: {
      padding: theme.spacing(2),
      whiteSpace: "pre-line", // \nで改行用
    },
    text: {
      fontSize: 20,
      background:
        "linear-gradient(90deg, rgba(237, 119, 128, 0) 0%, rgba(237, 119, 128, 0) 50%, #fff 0%, #fff 100%), linear-gradient(180deg, rgba(100, 100, 100, 0) 0%, rgba(100, 100, 100, 0) 97.5%, #646464 100%)",
      backgroundSize: "8px 100%,100% 2em",
      lineHeight: "2em",
    },
    subheader: {
      fontSize: 20,
    },
    title: {
      fontSize: 24,
      fontWeight: "bolder",
    },
    cardPadding: {
      padding: 0,
    },
    nothing: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "pre-line",
      fontSize: 22,
      marginTop: theme.spacing(22),
    },
    initialloader: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(22),
    },
    moreLoader: {
      display: "flex",
      justifyContent: "center",
    },
  })
);

export default function Notification() {
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [isInitialLoading, setIsInitialLoading] = useStateSafe(true);
  const [hasMore, setHasMore] = useStateSafe(true);

  const errorRef = useRef({});
  const [isOpenError, setIsOpenError] = useStateSafe(false);
  const handleCloseError = useCallback(() => {
    setIsOpenError(false);
  }, [setIsOpenError]);

  const infoIdRef = useRef(null);

  useEffect(() => {
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMore = useCallback(async () => {
    await fetchNotification(infoIdRef.current)
      .then((res) => {
        const isError = !!res.data.error.length;
        const hasResult = !!res.data.result.length;
        const isMore = res.data.result.length === NOTIFICATION_MAX_SIZE;

        if (isError) {
          throw res.data.error;
        }

        if (hasResult) {
          infoIdRef.current = res.data.result.slice(-1)[0].info_id;
          setData([...data, ...res.data.result]);
        }

        if (!isMore) {
          setHasMore(false);
        }
      })
      .catch((err) => {
        errorRef.current = err.code
          ? getApiError(err)
          : errors.APP_CONNECTION_FAILED;
        setIsOpenError(true);
      });

    if (isInitialLoading) {
      setIsInitialLoading(false);
    }
  }, [
    data,
    isInitialLoading,
    setData,
    setHasMore,
    setIsOpenError,
    setIsInitialLoading,
  ]);

  return (
    <>
      <TopBar isLoading={isInitialLoading} />

      {isInitialLoading ? null : data.length === 0 ? (
        <Typography color="textSecondary" className={classes.nothing}>
          {"お知らせはありません"}
        </Typography>
      ) : (
        <InfiniteScroll
          initialLoad={false}
          loadMore={loadMore}
          hasMore={hasMore}
          loader={
            <div className={classes.moreLoader} key={0}>
              <CircularProgress />
            </div>
          }
        >
          <div className={classes.root}>
            <div className={classes.note}>
              {data.map((day, idx) => (
                <div className={classes.day} key={idx}>
                  <Card
                    elevation={3}
                    className={classes.paper}
                    classes={{ root: classes.cardPadding }}
                  >
                    <CardHeader
                      title={day.subject}
                      subheader={format(
                        new Date(day.date),
                        `M月d日(${get曜日(new Date(day.date))})`
                      )}
                      classes={{
                        subheader: classes.subheader,
                        title: classes.title,
                      }}
                    />

                    <CardContent>
                      <Typography
                        className={classNames(classes.text, "canSelect")}
                      >
                        {day.body}
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </InfiniteScroll>
      )}

      <ErrorDialog
        open={isOpenError}
        onClose={handleCloseError}
        error={errorRef.current}
      />
    </>
  );
}
